import {Action} from '@ngrx/store';
import {DeviceSelectionMode} from '../enums/device-selection-mode.enum';
import {AddSelectedDevicePayload, RemoveSelectedDevicePayload, SetSelectedDevicePayload} from '../models/dashboard-device';

export enum DashboardDeviceActionTypes {
  AddSelectedDevice = '[DashboardDevice] Add Selected Device',
  RemoveSelectedDevice = '[DashboardDevice] Remove Selected Device',
  SetSelectedDevice = '[DashboardDevice] Set Selected Device',
  EmptySelectedDevice = '[DashboardDevice] Empty Selected Device',
  SetDeviceSelectionMode = '[DashboardDevice] Set Device Selection Mode'
}

export class AddSelectedDevice implements Action {
  readonly type = DashboardDeviceActionTypes.AddSelectedDevice;

  constructor(public payload: AddSelectedDevicePayload) {
  }
}

export class RemoveSelectedDevice implements Action {
  readonly type = DashboardDeviceActionTypes.RemoveSelectedDevice;

  constructor(public payload: RemoveSelectedDevicePayload) {
  }
}

export class SetSelectedDevice implements Action {
  readonly type = DashboardDeviceActionTypes.SetSelectedDevice;

  constructor(public payload: SetSelectedDevicePayload) {
  }
}

export class EmptySelectedDevice implements Action {
  readonly type = DashboardDeviceActionTypes.EmptySelectedDevice;
}

export class SetDeviceSeletionMode implements Action {
  readonly type = DashboardDeviceActionTypes.SetDeviceSelectionMode;

  constructor(public payload: DeviceSelectionMode) {
  }
}

export type DashboardDeviceActions =
  | AddSelectedDevice
  | RemoveSelectedDevice
  | SetSelectedDevice
  | EmptySelectedDevice
  | SetDeviceSeletionMode;
